/* eslint-disable */
import { toRaw } from 'vue'
import U from '../lib-utils'
import abstractLayer from './abstractLayer'
import { central_data } from './lib-central-data'
import events from './lib-events'

/**
 *
 * @param {type} layout
 * @returns {layer.F|layer.init}
 */
function wallLayer(layout) {
  return (wallLayer.is(this) ? this.init : wallLayer.F).apply(
    this,
    Array.prototype.slice.call(arguments),
  )
}

var P = wallLayer.leu_extend(abstractLayer).prototype

P.handle = null
P.enabled = true
P.canvas = null
P.context = null
P.tempWallEndX = null
P.tempWallEndY = null
P.drawedWall = null
P.hoveredWall = null
P.selectedWall = null
P.actionBlock = null
P.editingWall = null
P.editingPointIndex = null
P.selectedPointIndex = null
P.hoveredPointIndex = null
P.isDraggingPoint = false
P.ctrlKey = false
P.altKey = false

P.active = false
P.wallColor = '#000000'
P.wallWidth = 2
P.walls = []

const HIGHLIGHT_THRESHOLD_LINE = 5
const HIGHLIGHT_THRESHOLD_POINT = 10

P.on_init = function (layout) {
  this.handle = document.createElement('div')
  this.handle.classList.add('lib-map-layer')
  this.handle.classList.add('lib-map-layer-wall-v-cnv')
  this.canvas = document.createElement('canvas')
  this.handle.appendChild(this.canvas)
  this.context = this.canvas.getContext('2d')
  this.enabled = true
  this.layout.centralData.lem.on(events._WALL_ACTIVATE, this, this.startWall)
  this.layout.centralData.lem.on(events._WALL_DEACTIVATE, this, this.endWall)
  this.layout.centralData.lem.on(
    events._WALL_GET_WALLS_FROM_PROJECT,
    this,
    (_, data) => this.getWallsFromProject(data),
  )
  this.layout.centralData.lem.on(
    events._GET_WALL_LAYER,
    this,
    this.get_wall_layer,
  )
  this.layout.centralData.lem.on(
    events._WALL_PREFERENCES_CHANGED,
    this,
    (_, data) => this.onPreferencesChanged(data),
  )

  this.layout.centralData.lem.run(events._WALL_GET_DATA_HOT_RELOAD)

  if (localStorage.getItem('visible-sidebar-menu') === 'wall') {
    this.active = true
  }

  this.handleKeyup()
  this.handleSelectWall()
  this.handleShowContextMenu()
  this.handleMouseMove()
  this.handleMouseDown()
  this.handleMouseUp()
  return this
}

/**
 * Получить данные стен со стороны интерфейса Vue
 */
P.getWallsFromProject = function (walls) {
  if (walls) {
    this.setWalls(toRaw(walls))

    const selectedWall = this.walls.find(w => w.selected)
    const hoveredWall = this.walls.find(w => w.hovered)

    this.selectedWall = selectedWall || null
    this.hoveredWall = hoveredWall || null
    this.draw()
  }
}

/**
 * Изменение настроек стены
 */
P.onPreferencesChanged = function (data) {
  if (data) {
    this.wallColor = data.wallColor || this.wallColor
    this.wallWidth = data.wallWidth || this.wallWidth
    this.draw()
  }
}

/**
 * Установить выбранную стену
 * @param {(Object|null)} wall - Объект стены или null, если нужно снять выделение
 */
P.setSelectedWall = function (wall) {
  this.selectedWall = wall
  this.setWalls(
    this.walls.map(w => ({
      ...w,
      selected: wall === null ? false : w.id === wall.id,
    })),
  )
}

/**
 * Определить выделенную стену
 * @param {(Object|null)} wall - Объект стены или null, если нужно снять наведение
 */
P.setHoveredWall = function (wall) {
  if (
    (this.hoveredWall === null && wall === null) ||
    this.hoveredWall?.id === wall?.id
  ) {
    return
  }

  this.hoveredWall = wall
  this.setWalls(
    this.walls.map(w => ({
      ...w,
      hovered: wall === null ? false : w.id === wall.id,
    })),
  )
}

P.handleShowContextMenu = function () {
  this.layout.event_inceptor.addEventListener('contextmenu', event => {
    event.preventDefault()

    if (this.hoveredWall) {
      this.setSelectedWall(this.hoveredWall)
    }

    if (this.hoveredWall || this.selectedWall) {
      this.layout.setCanvasIsMoved(false)
      this.showActionBlock(event)
      this.draw()
    }
  })
}

/**
 * Обработка выбора выделенной стены
 */
P.handleSelectWall = function () {
  document.addEventListener('click', () => {
    if (this.hoveredWall) {
      this.setSelectedWall(this.hoveredWall)
      this.draw()
    }
  })
}

/**
 * Показать блок с действиями
 */
P.showActionBlock = function (event) {
  if (!this.actionBlock) {
    this.createActionBlock(event)
  }

  this.actionBlock.style.top = event.clientY + 'px'
  this.actionBlock.style.left = event.clientX + 'px'
}

/**
 * Активировать конструктор стен
 */
P.startWall = function () {
  this.active = true
  this.layout.centralData.lem.run(events._WALL_STATUS_CHANGED)
  this.draw()
}

/**
 * Деактивировать конструктор стен
 */
P.endWall = function () {
  this.active = false
  this.layout.centralData.lem.run(events._WALL_STATUS_CHANGED)
  this.draw()
}

/**
 * Создать объект данных для передачи на сторону интерфейса Vue
 */
function createWallData({ walls, wallColor, wallWidth }) {
  const data = {
    walls,
    wallColor,
    wallWidth,
  }
  return data
}

/**
 * Установить стены
 */
P.setWalls = function (walls) {
  this.walls = walls
  central_data().lem.run(events._WALL_UPDATE_DATA, createWallData({ walls }))
}

/**
 * Получить кастомные данные слоя со стенами (текущего слоя)
 */
P.getCustomDataLayer = function () {
  const customData = this.layout.centralData.project?.custom_data

  if (!customData) {
    return null
  }

  if (!customData.wall) {
    customData.wall = {}
  }

  return customData.wall
}

/**
 * Создать блок с действиями
 */
P.createActionBlock = function (event) {
  const ACTION_BLOCK_ID = 'wall-actions-block'

  if (document.getElementById(ACTION_BLOCK_ID)) {
    document.getElementById(ACTION_BLOCK_ID).remove()
  }

  this.actionBlock = document.createElement('div')
  this.actionBlock.classList.add('wallActions')
  this.actionBlock.id = 'wall-actions-block'
  document.body.appendChild(this.actionBlock)

  const list = document.createElement('ul')
  list.classList.add('wallActions-list')
  this.actionBlock.appendChild(list)

  const itemDrawing = document.createElement('li')
  itemDrawing.classList.add('wallActions-item')
  itemDrawing.textContent = 'Продолжить рисовать'
  list.appendChild(itemDrawing)

  const itemEditing = document.createElement('li')
  itemEditing.classList.add('wallActions-item')
  itemEditing.textContent = 'Редактировать'
  list.appendChild(itemEditing)

  const itemRemoving = document.createElement('li')
  itemRemoving.classList.add('wallActions-item')
  itemRemoving.textContent = 'Удалить'
  list.appendChild(itemRemoving)

  itemDrawing.addEventListener('click', clickEvent => {
    this.setDrawedWall(this.selectedWall)
    const calculationResult = this.layout.calculation_result
    const translatedViewportPX = this.layout.calculator.translate_viewport_px(
      event.offsetX + clickEvent.offsetX,
      event.offsetY + clickEvent.offsetY,
      calculationResult.viewport.w,
      calculationResult.viewport.h,
      calculationResult.scale,
      calculationResult.center.pcu.x,
      calculationResult.center.pcu.y,
    )
    this.tempWallEndX = translatedViewportPX.image.pcu.x
    this.tempWallEndY = translatedViewportPX.image.pcu.y
    this.setHoveredWall(null)
    this.setSelectedWall(null)
    this.layout.setCanvasIsMoved(true)
    this.removeActionBlock()
    this.draw()
  })

  itemRemoving.addEventListener('click', () => {
    this.removeWall(this.selectedWall.id)
    this.layout.setCanvasIsMoved(true)
    this.removeActionBlock()
  })

  itemEditing.addEventListener('click', () => {
    this.editWall(this.selectedWall)
    this.removeActionBlock()
  })
}

/**
 * Удалить стену
 */
P.removeWall = function (wallId) {
  this.setWalls(this.walls.filter(wall => wall.id !== wallId))
  this.setHoveredWall(null)
  this.setSelectedWall(null)
  this.draw()
}

/**
 * Определить стену для редактирования
 */
P.editWall = function (wall) {
  this.editingWall = wall
  this.setHoveredWall(null)
  this.setSelectedWall(null)
  this.layout.setCanvasIsMoved(false)
  this.draw()
}

/**
 * Удалить блок с действиями
 */
P.removeActionBlock = function () {
  this.actionBlock.remove()
  this.actionBlock = null
}

/**
 * Определить рисуемую стену
 */
P.setDrawedWall = function (wall) {
  this.drawedWall = wall
}

/**
 * Обновить стиль курсора
 */
P.updateCursor = function () {
  let cursor

  if (!this.active) {
    this.layout.event_inceptor.style.cursor = null
    return
  }

  if (this.isDraggingPoint) {
    cursor = 'grabbing'
  } else if (
    this.hoveredWall ||
    this.selectedWall ||
    this.hoveredPointIndex !== null
  ) {
    cursor = 'pointer'
  } else {
    cursor = 'crosshair'
  }

  this.layout.event_inceptor.style.cursor = cursor
}

/**
 * Обработка наведения
 */
P.on_hover = function (event) {
  if (!this.active) {
    return
  }

  if (this.drawedWallHavePoints()) {
    if (event.ctrlKey || event.metaKey) {
      this.tempWallEndX = event.calculated.image.pcu.x
      this.tempWallEndY = this.drawedWall.points.at(-1).y
      this.ctrlKey = true
    } else if (event.altKey) {
      this.tempWallEndY = event.calculated.image.pcu.y
      this.tempWallEndX = this.drawedWall.points.at(-1).x
      this.altKey = true
    } else {
      this.tempWallEndX = event.calculated.image.pcu.x
      this.tempWallEndY = event.calculated.image.pcu.y
      this.ctrlKey = false
      this.altKey = false
    }
  }

  if (!this.drawedWall && !this.editingWall) {
    // Проверка наведения на стены
    const layoutWidth = this.layout.layout_width
    const layoutHeight = this.layout.layout_height
    const scale = this.layout.scale
    const centerX = this.layout.center_x
    const centerY = this.layout.center_y
    let hoveredWall = null

    this.walls.forEach(wall => {
      for (let i = 0; i < wall.points.length - 1; i++) {
        const point1 = wall.points[i]
        const point2 = wall.points[i + 1]
        const translated1 = this.layout.calculator.translate_image_pcu(
          point1.x,
          point1.y,
          layoutWidth,
          layoutHeight,
          scale,
          centerX,
          centerY,
        )
        const translated2 = this.layout.calculator.translate_image_pcu(
          point2.x,
          point2.y,
          layoutWidth,
          layoutHeight,
          scale,
          centerX,
          centerY,
        )
        const distance = pointToLineDistance(
          translated1.viewport.px.x,
          translated1.viewport.px.y,
          translated2.viewport.px.x,
          translated2.viewport.px.y,
          event.offsetX,
          event.offsetY,
        )
        if (distance < HIGHLIGHT_THRESHOLD_LINE) {
          // Пороговое значение для выделения
          hoveredWall = wall
          break
        }
      }
    })

    this.setHoveredWall(hoveredWall)
  }

  this.updateCursor()
  this.draw()
}

P.get_wall_layer = function (evt, ro) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  canvas.width = this.get_image_width()
  canvas.height = this.get_image_height()

  const layoutWidth = canvas.width
  const layoutHeight = canvas.height
  const scale = 1
  const centerX = 50
  const centerY = 50

  // Отрисовка всех сохранённых стен
  this.walls.forEach(wall => {
    context.beginPath()

    wall.points.forEach((point, index) => {
      var translated = this.layout.calculator.translate_image_pcu(
        point.x,
        point.y,
        layoutWidth,
        layoutHeight,
        scale,
        centerX,
        centerY,
      )

      if (index === 0) {
        context.moveTo(translated.viewport.px.x, translated.viewport.px.y)
      } else {
        context.lineTo(translated.viewport.px.x, translated.viewport.px.y)
      }
    })

    context.strokeStyle = wall.color
    context.lineWidth = wall.width * scale
    context.stroke()
  })

  ro.callback(canvas)
}

/**
 * Сбросит рисование стены, если есть стена в стадии рисования
 */
P.handleKeyup = function () {
  document.addEventListener('keyup', e => {
    if (this.drawedWall) {
      if (e.code === 'Escape' || e.code === 'Enter') {
        if (this.drawedWall.points.length < 2) {
          this.setWalls([
            ...this.walls.filter(wall => wall.id !== this.drawedWall.id),
          ])
        }
        this.clearDrawedWall()
        return
      }
    }

    if (this.selectedWall) {
      if (e.code === 'Escape') {
        this.setSelectedWall(null)
        this.layout.setCanvasIsMoved(true)

        if (this.actionBlock) {
          this.removeActionBlock()
        }
        this.draw()
        return
      }

      if (e.code === 'Delete') {
        this.removeWall(this.selectedWall.id)
        this.updateCursor()

        if (this.actionBlock) {
          this.layout.setCanvasIsMoved(true)
          this.removeActionBlock()
        }
        return
      }

      if (e.code === 'Enter') {
        this.editWall(this.selectedWall)
        return
      }
    }

    if (this.editingWall) {
      if (e.code === 'Enter' || e.code === 'Escape') {
        this.editingWall = null
        this.editingPointIndex = null
        this.selectedPointIndex = null
        this.isDraggingPoint = false
        this.layout.setCanvasIsMoved(true)
        this.draw()
        return
      }
    }

    if (this.selectedPointIndex !== null) {
      if (e.code === 'Delete') {
        this.editingWall.points.splice(this.selectedPointIndex, 1)
        this.selectedPointIndex = null

        if (this.editingWall.points.length === 1) {
          this.setWalls([
            ...this.walls.filter(wall => wall.id !== this.editingWall.id),
          ])
          this.editingWall = null
          this.layout.setCanvasIsMoved(true)
        }

        this.draw()
        return
      }
    }
  })
}

/**
 * Очистка рисуемой стены
 */
P.clearDrawedWall = function () {
  this.setDrawedWall(null)
  this.tempWallEndX = null
  this.tempWallEndY = null
  this.draw()
  this.layout.centralData.lem.run(events._WALL_STATUS_CHANGED)
}

/**
 * Обработка кликов
 */
P.on_click_tap = function (evt) {
  if (!this.active) {
    return
  }

  if (this.isDraggingPoint) {
    this.updateCursor()
    return
  }

  if (this.hoveredWall) {
    return
  }

  if (this.selectedWall) {
    this.setSelectedWall(null)
    if (this.actionBlock) {
      this.removeActionBlock()
    }
    this.layout.setCanvasIsMoved(true)
    this.updateCursor()
    this.draw()
    return
  }

  if (this.editingWall) {
    return
  }

  if (evt.preventDefault) {
    evt.preventDefault()
  } else {
    evt.returnValue = false
  }
  evt.stopPropagation()

  // Координаты точки клика
  const point = this.createPoint(
    evt.calculated.image.pcu.x,
    evt.calculated.image.pcu.y,
  )

  if (!this.drawedWallHavePoints()) {
    this.setDrawedWall(this.createWall(point))
    this.setWalls([...this.walls, this.drawedWall])
  } else {
    this.drawedWall.points.push(point)
    this.setWalls(
      this.walls.map(wall =>
        wall.id === this.drawedWall.id ? this.drawedWall : wall,
      ),
    )
  }

  this.updateCursor()
  this.draw()
  return true
}

/**
 * Проверка наличия точек у рисуемой стены
 */
P.drawedWallHavePoints = function () {
  return this.drawedWall !== null && this.drawedWall.points.length > 0
}

/**
 * Рисование стены
 */
P.draw = function () {
  const ACCENT_COLOR = '#0C8CE9'
  const ACCENT_HOVERED_COLOR = '#C5E4F9'
  const SECOND_COLOR = 'white'

  this.context.clearRect(
    0,
    0,
    this.get_layout_width(),
    this.get_layout_height(),
  )
  if (!this.enabled) {
    return
  }

  if (!this.layout.calculator) {
    return
  }

  const layoutWidth = this.layout.layout_width
  const layoutHeight = this.layout.layout_height
  const scale = this.layout.scale
  const centerX = this.layout.center_x
  const centerY = this.layout.center_y

  // Отрисовка всех сохранённых стен
  this.walls.forEach(wall => {
    this.context.beginPath()

    wall.points.forEach((point, index) => {
      var translated = this.layout.calculator.translate_image_pcu(
        point.x,
        point.y,
        layoutWidth,
        layoutHeight,
        scale,
        centerX,
        centerY,
      )

      if (index === 0) {
        this.context.moveTo(translated.viewport.px.x, translated.viewport.px.y)
      } else {
        this.context.lineTo(translated.viewport.px.x, translated.viewport.px.y)
      }
    })

    this.context.strokeStyle = wall.color
    this.context.globalAlpha = this.active && wall.hovered ? 0.5 : 1.0
    this.context.lineWidth = wall.width * scale
    this.context.stroke()
    this.context.globalAlpha = 1

    // Отрисовка рамки вокруг выделенной стены
    if (this.active && wall.selected) {
      const minX = Math.min(...wall.points.map(p => p.x))
      const minY = Math.min(...wall.points.map(p => p.y))
      const maxX = Math.max(...wall.points.map(p => p.x))
      const maxY = Math.max(...wall.points.map(p => p.y))

      const topLeft = this.layout.calculator.translate_image_pcu(
        minX,
        minY,
        layoutWidth,
        layoutHeight,
        scale,
        centerX,
        centerY,
      )
      const bottomRight = this.layout.calculator.translate_image_pcu(
        maxX,
        maxY,
        layoutWidth,
        layoutHeight,
        scale,
        centerX,
        centerY,
      )

      this.context.strokeStyle = ACCENT_COLOR
      this.context.lineWidth = 2
      this.context.strokeRect(
        topLeft.viewport.px.x,
        topLeft.viewport.px.y,
        bottomRight.viewport.px.x - topLeft.viewport.px.x,
        bottomRight.viewport.px.y - topLeft.viewport.px.y,
      )

      // const cornerSize = 10
      // const corners = [
      //   [topLeft.viewport.px.x, topLeft.viewport.px.y],
      //   [bottomRight.viewport.px.x, topLeft.viewport.px.y],
      //   [topLeft.viewport.px.x, bottomRight.viewport.px.y],
      //   [bottomRight.viewport.px.x, bottomRight.viewport.px.y],
      // ]

      // this.context.fillStyle = SECOND_COLOR
      // this.context.strokeStyle = ACCENT_COLOR
      // this.context.lineWidth = 2
      // corners.forEach(corner => {
      //   this.context.fillRect(
      //     corner[0] - cornerSize / 2,
      //     corner[1] - cornerSize / 2,
      //     cornerSize,
      //     cornerSize,
      //   )
      //   this.context.strokeRect(
      //     corner[0] - cornerSize / 2,
      //     corner[1] - cornerSize / 2,
      //     cornerSize,
      //     cornerSize,
      //   )
      // })
    }
  })

  // Отрисовка временной стены, если начальные координаты заданы
  if (
    this.drawedWallHavePoints() &&
    this.tempWallEndX !== null &&
    this.tempWallEndY !== null
  ) {
    var tempStart = this.layout.calculator.translate_image_pcu(
      this.drawedWall.points.at(-1).x,
      this.drawedWall.points.at(-1).y,
      layoutWidth,
      layoutHeight,
      scale,
      centerX,
      centerY,
    )
    var tempEnd = this.layout.calculator.translate_image_pcu(
      this.tempWallEndX,
      this.tempWallEndY,
      layoutWidth,
      layoutHeight,
      scale,
      centerX,
      centerY,
    )

    this.context.beginPath()
    this.context.moveTo(tempStart.viewport.px.x, tempStart.viewport.px.y)
    this.context.lineTo(tempEnd.viewport.px.x, tempEnd.viewport.px.y)
    this.context.strokeStyle = this.wallColor
    this.context.lineWidth = this.wallWidth * scale
    this.context.stroke()
  }

  // Отрисовка точек редактируемой стены
  if (this.editingWall) {
    const POINT_SIZE = HIGHLIGHT_THRESHOLD_POINT / 1.5

    this.editingWall.points.forEach((point, index) => {
      const isHovered = this.hoveredPointIndex === index
      const isSelected = this.selectedPointIndex === index
      const translated = this.layout.calculator.translate_image_pcu(
        point.x,
        point.y,
        layoutWidth,
        layoutHeight,
        scale,
        centerX,
        centerY,
      )

      if (isSelected) {
        this.context.beginPath()
        this.context.arc(
          translated.viewport.px.x,
          translated.viewport.px.y,
          POINT_SIZE,
          0,
          2 * Math.PI,
        )
        this.context.fillStyle = SECOND_COLOR
        this.context.fill()

        this.context.beginPath()
        this.context.arc(
          translated.viewport.px.x,
          translated.viewport.px.y,
          POINT_SIZE / 1.9,
          0,
          2 * Math.PI,
        )
        this.context.fillStyle = isHovered ? ACCENT_HOVERED_COLOR : ACCENT_COLOR
        this.context.fill()
      } else {
        this.context.beginPath()
        this.context.arc(
          translated.viewport.px.x,
          translated.viewport.px.y,
          POINT_SIZE,
          0,
          2 * Math.PI,
        )
        this.context.fillStyle = isHovered ? ACCENT_HOVERED_COLOR : ACCENT_COLOR
        this.context.fill()

        this.context.beginPath()
        this.context.arc(
          translated.viewport.px.x,
          translated.viewport.px.y,
          POINT_SIZE / 1.8,
          0,
          2 * Math.PI,
        )
        this.context.fillStyle = SECOND_COLOR
        this.context.fill()
      }
    })
  }
}

/**
 * Вызывается менеджером после ресайза
 */
P.resize = function () {
  this.canvas.width = this.get_layout_width()
  this.canvas.height = this.get_layout_height()
  return this
}

/**
 * Создать объект стены
 */
P.createWall = function (firstPoint) {
  return {
    id: U.get_uuid(),
    name: `Стена ${this.walls.length + 1}`,
    points: [firstPoint],
    color: this.wallColor,
    width: this.wallWidth,
    selected: false,
    hovered: false,
  }
}

/**
 * Создать объект точки
 */
P.createPoint = function (x, y) {
  return {
    x,
    y,
    selected: false,
    hovered: false,
  }
}

/**
 * Вычисляет расстояние от точки до линии
 * @param {Number} x1 - координата x первой точки линии
 * @param {Number} y1 - координата y первой точки линии
 * @param {Number} x2 - координата x второй точки линии
 * @param {Number} y2 - координата y второй точки линии
 * @param {Number} px - координата x точки
 * @param {Number} py - координата y точки
 * @returns {Number} - расстояние от точки до линии
 */
function pointToLineDistance(x1, y1, x2, y2, px, py) {
  const A = px - x1
  const B = py - y1
  const C = x2 - x1
  const D = y2 - y1

  const dot = A * C + B * D
  const len_sq = C * C + D * D
  const param = len_sq !== 0 ? dot / len_sq : -1

  let xx, yy

  if (param < 0) {
    xx = x1
    yy = y1
  } else if (param > 1) {
    xx = x2
    yy = y2
  } else {
    xx = x1 + param * C
    yy = y1 + param * D
  }

  const dx = px - xx
  const dy = py - yy
  return Math.sqrt(dx * dx + dy * dy)
}

/**
 * Обработка движения мыши
 */
P.handleMouseMove = function () {
  document.addEventListener('mousemove', event => {
    if (
      this.isDraggingPoint &&
      this.editingWall &&
      this.editingPointIndex !== null
    ) {
      const point = this.editingWall.points[this.editingPointIndex]
      const calculationResult = this.layout.calculation_result
      const translatedViewportPX = this.layout.calculator.translate_viewport_px(
        event.offsetX,
        event.offsetY,
        calculationResult.viewport.w,
        calculationResult.viewport.h,
        calculationResult.scale,
        calculationResult.center.pcu.x,
        calculationResult.center.pcu.y,
      )
      point.x = translatedViewportPX.image.pcu.x
      point.y = translatedViewportPX.image.pcu.y
      this.draw()
    }

    if (this.editingWall) {
      const layoutWidth = this.layout.layout_width
      const layoutHeight = this.layout.layout_height
      const scale = this.layout.scale
      const centerX = this.layout.center_x
      const centerY = this.layout.center_y

      let hoveredPointIndex = null

      this.editingWall.points.forEach((point, index) => {
        const translated = this.layout.calculator.translate_image_pcu(
          point.x,
          point.y,
          layoutWidth,
          layoutHeight,
          scale,
          centerX,
          centerY,
        )
        const distance = Math.sqrt(
          Math.pow(translated.viewport.px.x - event.offsetX, 2) +
            Math.pow(translated.viewport.px.y - event.offsetY, 2),
        )
        if (distance < HIGHLIGHT_THRESHOLD_POINT) {
          hoveredPointIndex = index
        }
      })

      this.hoveredPointIndex = hoveredPointIndex
    }

    this.updateCursor()
  })
}

/**
 * Обработка нажатия кнопки мыши
 */
P.handleMouseDown = function () {
  document.addEventListener('mousedown', event => {
    if (this.editingWall) {
      const layoutWidth = this.layout.layout_width
      const layoutHeight = this.layout.layout_height
      const scale = this.layout.scale
      const centerX = this.layout.center_x
      const centerY = this.layout.center_y
      let selectedPointIndex = null

      this.editingWall.points.forEach((point, index) => {
        const translated = this.layout.calculator.translate_image_pcu(
          point.x,
          point.y,
          layoutWidth,
          layoutHeight,
          scale,
          centerX,
          centerY,
        )
        const distance = Math.sqrt(
          Math.pow(translated.viewport.px.x - event.offsetX, 2) +
            Math.pow(translated.viewport.px.y - event.offsetY, 2),
        )
        if (distance < HIGHLIGHT_THRESHOLD_POINT) {
          selectedPointIndex = index
          this.editingPointIndex = index
          this.isDraggingPoint = true
        }
      })

      this.selectedPointIndex = selectedPointIndex
      this.draw()
      this.updateCursor()
    }
  })
}

/**
 * Обработка отпускания кнопки мыши
 */
P.handleMouseUp = function () {
  document.addEventListener('mouseup', () => {
    this.editingPointIndex = null
    this.isDraggingPoint = false
  })
}

export default wallLayer
